import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { BasicObjectSMI, PreguntaEvidencia } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class PreguntaEvidenciaService {

  private controlador = computed(() => 'evidenciapregunta');
  private api = new ConsumirApi(this.controlador());

  constructor(){}

  public obtenerTodos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`todos/${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/todos/${idEmpresa}`);
  }

  public obtenerActivos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idEmpresa}`);
  }

  public obtenerPorId(idEmpresa:number, idsupervisor: number): Observable<PreguntaEvidencia>{
    return from(this.api.get<PreguntaEvidencia>(`${idEmpresa}/${idsupervisor}`));
    // return this.http.get<preguntaEvidenciaDTO>(`${this.apiURL}/${idEmpresa}/${idsupervisor}`);
  }

  public crear(registro:PreguntaEvidencia){
    return from(this.api.post<PreguntaEvidencia, boolean>(``, registro));
    // return this.http.post(this.apiURL, registro);
  }

  public validarNombre(registro:PreguntaEvidencia){
    return from(this.api.post<PreguntaEvidencia, boolean>(`validarPreguntaEvidencia`, registro));
    // return this.http.post(`${this.apiURL}/validarPreguntaEvidencia`, registro);
  }

  public editar(id: number, registro:PreguntaEvidencia){
    return from(this.api.put<PreguntaEvidencia, boolean>(`${id}`, registro));
    // return this.http.put(`${this.apiURL}/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}
